import { MeshRenderable } from "../rendering/mesh/MeshRenderable";
import { FacetRenderer, isRenderableType, RenderableUpdateTriggerState } from "../rendering/renderable/Renderable";
import { navMeshService } from "./NavMeshService";
import { modelPool } from "@modules/model";
export class NavMeshRenderable extends FacetRenderer {
    constructor(owner) {
        super(owner);
        this.owner = owner;
        this.enabled = true;
    }
    get layerId() {
        var _a;
        if (this.facet === undefined)
            return undefined;
        const room = (_a = modelPool.getModel(this.owner.modelUID)) === null || _a === void 0 ? void 0 : _a.getRoom();
        if (room === undefined)
            return undefined;
        return `${room.getName()}_${this.facet.layerId}`;
    }
    destroy() {
        navMeshService.removeNavMesh(this);
    }
    setVisible(visible) {
        const changed = visible !== this.enabled;
        this.enabled = visible;
        this.hideMeshIfNeeded();
        if (changed && this.layerId !== undefined) {
            navMeshService.requestBuildNavMesh(this.layerId);
        }
    }
    onInit(facet) {
        this.facet = facet;
        this.subscribeRoomChange();
        navMeshService.addNavMesh(this);
        this.buildNavMesh();
    }
    updateFacet(facet) {
        if (this.facet && this.facet.layerId !== facet.layerId) {
            if (this.layerId !== undefined) {
                navMeshService.requestBuildNavMesh(this.layerId);
            }
            console.log("Update nav mesh");
        }
    }
    updateTransform() {
        navMeshService.updateNavMesh(this);
    }
    onOtherRenderableChanged(state) {
        switch (state) {
            case RenderableUpdateTriggerState.Created:
            case RenderableUpdateTriggerState.Init:
            case RenderableUpdateTriggerState.Loaded:
            case RenderableUpdateTriggerState.Updated:
                this.hideMeshIfNeeded();
                break;
            case RenderableUpdateTriggerState.Changed:
                this.hideMeshIfNeeded();
                if (this.layerId !== undefined) {
                    navMeshService.requestBuildNavMesh(this.layerId);
                }
                break;
            case RenderableUpdateTriggerState.Destroyed:
                break;
        }
    }
    onRoomChanged() {
        this.hideMeshIfNeeded();
    }
    buildNavMesh() {
        if (!this.enabled)
            return;
        const renderable = this.owner.renderable;
        if (!renderable)
            return;
        if (!isRenderableType(MeshRenderable, renderable))
            return;
        this.hideMeshIfNeeded();
        if (!renderable.meshInstance.isLoaded)
            return;
        if (this.layerId === undefined)
            return;
        navMeshService.requestBuildNavMesh(this.layerId);
    }
    hideMeshIfNeeded() {
        const renderable = this.owner.renderable;
        if (renderable === undefined)
            return;
        if (!isRenderableType(MeshRenderable, renderable))
            return;
        if (this.facet === undefined)
            return;
        if (!this.facet.hideMesh)
            return;
        renderable.setVisible(false);
    }
}
